/*
 * View for the snippets list
 */

define(["marionette", "./template/snippetListTemplate.html"], function (
  Marionette,
  SnippetListTemplate,
) {
  "use strict";

  const SnippetListView = {};

  SnippetListView.snippetListLayout = Marionette.Layout.extend({
    template: SnippetListTemplate,
    regions: {
      controls: "#snippetsControls",
      list: "#list",
    },
  });

  return SnippetListView;
});
